<template>
  <div class="w-full flex justify-center pb-12">
    <div class="relative text-center">
      <p class="text-6xl uppercase font-black">
        {{ __('label_partner') }}
      </p>

      <p
        class="text-6xl leading-[1.5rem] font-satisfy"
        :style="{
          color: 'rgb(211, 18, 148)',
        }"
      >
        {{ __('label_brands') }}
      </p>
    </div>
  </div>

  <div class="flex justify-center">
    <div class="w-2/3">
      <div
        class="grid space-x-4 gap-y-4"
        :class="gridColsClass"
      >
        <div
          v-for="(brand, index) in config.body?.partner_brands ?? []"
          :key="index"
          class="flex justify-center"
        >
          <img
            class="h-32 w-32 object-contain"
            :src="brand.logo_url"
            alt="Logo"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },
});

const gridColsClass = ref([
  'grid-cols-1',
  'grid-cols-2',
  'grid-cols-2 sm:grid-cols-3',
  'grid-cols-2 sm:grid-cols-4',
][props.config.body?.partner_brands_columns - 1] ?? 'grid-cols-4');
</script>
